import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext } from "react";
export const TabContext = createContext(undefined);
export const useTab = () => {
    const context = useContext(TabContext);
    if (!context)
        throw new Error("useTab must be use inside Tab Provider(<GrTab.Group>)");
    return context;
};
export const TabProvider = ({ children, value, color, size }) => {
    return _jsx(TabContext.Provider, { value: { value, color, size }, children: children });
};
//# sourceMappingURL=tabContext.js.map